import React from "react";
import PropTypes from "prop-types";
import { ChartTitle } from "@progress/kendo-react-charts";

/**
 * ChartTitleComponent
 * @class
 * @property {object} titleProps - Props of module ChartTitle
 */

/**
 * ChartTitle
 * @module
 * @property {string} text - Text
 */

const ChartTitleComponent = (props) => {
  const { titleProps } = props;
  return <ChartTitle text={titleProps.text} />;
};

ChartTitleComponent.propTypes = {
  titleProps: PropTypes.shape({
    text: PropTypes.string,
  }),
};

export default ChartTitleComponent;
